import './assets/styles/fonts.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import MotorradHeader from './components/MotorradHeader';
import MotorradFooter from './components/MotorradFooter';

import Motorrad from './pages/Motorrad';
import AllMotoModels from './pages/AllMotoModels';
import ModelDetail from './pages/ModelDetail';
import MotorradServiceRequest from './pages/MotorradServiceRequest';
import MotorradTestDrive from './pages/MotorradTestDrive';
import Contacts from './pages/Contacts';
import MotorradGetOffer from './pages/MotorradGetOffer';

const AppContent = () => {
  return (
    <div className="app-container" style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh'
    }}>
      <MotorradHeader />

      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Motorrad />} />
          <Route path="/moto_models" element={<AllMotoModels />} />
          <Route path="/motorrad/:id" element={<ModelDetail />} />
          <Route path="/service-request" element={<MotorradServiceRequest />} />
          <Route path="/test-drive" element={<MotorradTestDrive />} />
          <Route path="/get-offer" element={<MotorradGetOffer />} />
          <Route path="/contacts" element={<Contacts />} />
        </Routes>
      </main>

      <MotorradFooter />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;